import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	sources_icon_stack_text: {
		id: 'search_ai.sources_icon_stack_text',
		defaultMessage: '+{count} more',
		description: 'Text for the sources icon stack',
	},
	contributors_avatar_stack_text: {
		id: 'search_ai.contributors_avatar_stack_text',
		defaultMessage: '+{count} more',
		description: 'Text for the contributors avatar stack',
	},
	related_links_title: {
		id: 'search_ai.related_links_title',
		defaultMessage: 'Related Links',
		description: 'Text for the related links title',
	},
	contributors_title: {
		id: 'search_ai.contributors_title',
		defaultMessage: 'Collaborators',
		description: 'Text for the collaborators title',
	},
	contributors_card_subtitle: {
		id: 'search_ai.contributors_card_subtitle',
		defaultMessage: '{type, select, tagged {tagged on this page} other {{type} of this page}}',
		description: 'Text for the contributors card subtitle',
	},
	show_less_button_label: {
		id: 'search_ai.show_less_button_label',
		defaultMessage: 'Show less',
		description: 'Text for the show less button label',
	},
	page_icon_label: {
		id: 'search_ai.page_icon_label',
		defaultMessage: 'Page Icon',
		description: 'Text for the page icon label',
	},
	globe_icon_label: {
		id: 'search_ai.globe_icon_label',
		defaultMessage: 'Globe Icon',
		description: 'Text for the globe icon label',
	},
	confluence_product_name: {
		id: 'search_ai.confluence_product_name',
		defaultMessage: 'Confluence',
		description: 'Text for the confluence product name',
	},
	webpage_label: {
		id: 'search_ai.webpage_label',
		defaultMessage: 'Web page',
		description: 'Text for the webpage label',
	},
	contributors_card_hover_profile_link: {
		id: 'search_ai.contributors_card_hover_profile_link',
		defaultMessage: 'View profile',
		description: 'Hover text for contributor card profile link',
	},
});
